module.exports = __webpack_public_path__ + "img/licenseMetricsNodata.01c172d0.svg";